// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19CU6","name":"Header_name__3k-Al","birthday":"Header_birthday__3dsUj","skeleton":"Header_skeleton__UUUeQ"};